import styled, { css } from 'styled-components';
import { ReactComponent as Info } from './assets/info.svg';
import { StyledButton } from '../../../../globalStyled';
import { ReactComponent as StyledExpand } from '../../../../assets/img/info-card-icon-white.svg';

export const StyledInfo = styled(Info)`
  position: absolute;
  left: 4px;
  top: 4px;
`;
export const StyledInfoIcon = styled(StyledExpand)`
  margin-bottom: 3px;
`;

export const StyledPlayerCard = styled.div`
  /*   @-webkit-keyframes pulse {
    0% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 200, 15, 0.7);
    }
    70% {
      -webkit-box-shadow: 0 0 0 10px rgba(255, 200, 15, 0);
    }
    100% {
      -webkit-box-shadow: 0 0 0 0 rgba(255, 200, 15, 0);
    }
  }
  @keyframes pulse {
    0% {
      -moz-box-shadow: 0 0 0 0 rgba(255, 200, 15, 0.7);
      box-shadow: 0 0 0 0 rgba(255, 200, 15, 0.4);
    }
    70% {
      -moz-box-shadow: 0 0 0 10px rgba(255, 200, 15, 0);
      box-shadow: 0 0 0 10px rgba(255, 200, 15, 0);
    }
    100% {
      -moz-box-shadow: 0 0 0 0 rgba(255, 200, 15, 0);
      box-shadow: 0 0 0 0 rgba(255, 200, 15, 0);
    }
  } */
  cursor: pointer;
  width: 230px;
  position: relative;
  height: auto;
  min-height: 265px;
  padding: 0px;
  background-color: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0 2px 6px 7px rgba(0, 0, 0, 0.02);
  border-radius: ${({ theme }) => theme.cardRadius};
  margin: 20px auto;
  @media screen and (max-width: 768px) {
    width: 100%;
    min-height: 200px;
    height: auto;
    padding: 0;
    margin: 20px 0;
  }
  ${({ isDisabled }) => {
    if (isDisabled) {
      return css`
        opacity: 0.3;
        pointer-events: none;
      `;
    }
  }}
  /*   ${({ cardType }) => {
    if (cardType === 'buy') {
      return css`
        animation: pulse 1.5s infinite;
      `;
    }
  }} */


  > h5 {
    font-family: 'Archivo', sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.01em;
    color: ${({ theme }) => theme.text};
    text-align: center;
    margin-bottom: 10px;
  }
  ${({ selectPlayer }) => {
    if (selectPlayer) {
      return css`
        &.data-${selectPlayer} {
          background: ${({ theme }) =>
            theme.isDark ? 'rgba(14, 74, 251, 0.24)' : 'rgba(14, 74, 251, 0.12)'};
          > h5 {
            color: ${({ theme }) => theme.text};
          }
          p {
            /* border: none; */
          }
          svg {
            circle {
              fill: white;
            }
          }
        }
      `;
    }
  }}
`;

export const StyledInfoText = styled.p`
  user-select: none;
  display: flex;
  width: 100%;
  background: ${({ theme }) => theme.card};
  border: 1px solid ${({ theme }) => theme.border};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.06);
  border-radius: 5px;

  font-family: 'Archivo', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14.22px;
  line-height: 100%;
  text-align: center;
  letter-spacing: 0.015em;
  color: ${({ theme }) => theme.text};
  justify-content: center;
  padding: 13px 10px;
`;

export const StyledHeader = styled.div`
  height: 90px;
  position: relative;
  background-color: ${({ theme }) => theme.nav};
  font-family: 'Archivo', sans-serif;
  border-top-left-radius: max(0px, calc(${({ theme }) => theme.cardRadius} - 1px));
  border-top-right-radius: max(0px, calc(${({ theme }) => theme.cardRadius} - 1px));
  > img {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    object-fit: cover;
    opacity: 0.6;
    border-top-left-radius: inherit;
    border-top-right-radius: inherit;
  }
`;

const BANNER_COLORS = {
  Buy: { bg: '#3ecf7a', fold: '#1f9a52' },
  Sell: { bg: '#ffc80f', fold: '#d6a605' },
  'Loan In': { bg: '#4ea3ff', fold: '#2d6fc0' },
  'Loan Out': { bg: '#ff7b6b', fold: '#c44d42' },
};

export const StyledLabel = styled.span`
  position: absolute;
  left: -8px;
  top: 5px;
  background-color: ${({ $kind }) =>
    (BANNER_COLORS[$kind] || BANNER_COLORS.Buy).bg};
  color: #000;
  border-radius: 4px;
  border-bottom-left-radius: 0;
  font-family: 'Archivo', sans-serif;
  font-size: 9px;
  font-weight: 600;
  letter-spacing: 0.45px;
  text-transform: uppercase;
  z-index: 1;
  padding: 7px 15px;
  &:before {
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    border-top: 7px solid
      ${({ $kind }) => (BANNER_COLORS[$kind] || BANNER_COLORS.Buy).fold};
    border-left: 7px solid transparent;
    left: 0;
    top: 24px;
  }
`;

export const StyledInlineContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
`;

export const StyledButtonContainer = styled.div`
  display: flex;
  padding: 0 5px 10px 5px;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledName = styled.h5`
  color: #fff;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: center;
  margin-top: 20px;
  font-family: 'Archivo Condensed', 'Archivo', sans-serif;
  font-stretch: condensed;
  font-weight: 800;
  font-size: 18px;
`;

export const StyledDate = styled.span`
  position: relative;
  z-index: 1;
  color: rgba(255, 255, 255, 0.7);
  text-transform: uppercase;
  display: flex;
  flex-direction: column;
  font-family: 'Archivo', sans-serif;
  align-items: flex-end;
  justify-content: center;

  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.45px;
  padding-top: 7px;
  padding-right: 10px;
`;

export const StyledListedBar = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 7px 10px;
  border-bottom: 1px solid ${({ theme }) => theme.borderSubtle};
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-align: center;
  color: ${({ $listed, theme }) =>
    $listed ? '#f0a500' : theme.textFaint};
`;

export const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  @media only screen and (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  }
`;
export const StyledInfoItem = styled.div`
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ small }) => {
    if (small) {
      return css`
        height: 60px;
        width: 50%;
        &:first-of-type {
          border-right: 1px solid ${({ theme }) => theme.borderSubtle};
        }
      `;
    }
  }}
`;
export const StyledAmount = styled.div`
  font-family: 'Archivo', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  text-align: center;
`;
export const StyledInfoLabel = styled.div`
  color: ${({ theme }) => theme.textFaint};
  font-family: 'Archivo', sans-serif;
  font-size: 11px;
  font-weight: 500;
  text-align: center;
  margin-top: 5px;
`;

export const StyledCardButton = styled(StyledButton)`
  min-width: 138px;
  padding: 7px 10px;
  font-size: 10px;
  margin: 0;
  width: 100%;
  @media only screen and (max-width: 768px) {
    padding: 7px 10px;
  }
  ${({ small }) => {
    if (small) {
      return css`
        min-width: 88px;
        width: 49%;
        max-width: 100px;
        margin: 0 5px;
        flex-direction: row;
      `;
    }
  }}
  ${({ cancel, theme }) => {
    if (cancel) {
      return css`
        background: ${theme.hover};
        border: 1px solid ${theme.border};
        color: ${theme.danger};
        box-shadow: none;
      `;
    }
  }}
`;
